export const getPaymentsQuery = (params) => {
  let defaultParams = {tenantIds:[], propertyIds:[], unitIds:[],
    startDate: null, endDate: null, minAmount:0, maxAmount:0, status:[], paymentSources: [],
    searchText: "", unassigned: false, paymentIds: [], offset:""};
  let combinedParams = {...defaultParams, ...params};
  const {
    tenantIds, propertyIds, unitIds, startDate, endDate, minAmount,
    maxAmount, status, paymentSources, unassigned, searchText, offset, paymentIds
  } = combinedParams;

    const query = `
    query{
      payments(
        tenantIds: ${JSON.stringify(tenantIds)},
        propertyIds: ${JSON.stringify(propertyIds)},
        unitIds: ${JSON.stringify(unitIds)},
        startDate: ${ !startDate? JSON.stringify("") : JSON.stringify(startDate.format("YYYY-MM-DD"))},
        endDate: ${ !endDate? JSON.stringify("") : JSON.stringify(endDate.format("YYYY-MM-DD"))},
        minAmount:${JSON.stringify(minAmount)},
        maxAmount:${JSON.stringify(maxAmount)},
        status:${JSON.stringify(status)},
        source:${JSON.stringify(paymentSources)},
        unassigned: ${JSON.stringify(unassigned)},
        offset:${JSON.stringify(offset)},
        searchText: ${JSON.stringify(searchText)},
        paymentIds: ${JSON.stringify(paymentIds)},
        limit:50
      ){
        payments{
          id
          tenantDetails{
            tenantId
            firstName
            lastName
            unitId
            propertyId
            archived
        }
          amount
          paymentType
          description
          createdTs
          paymentDate
          status
          lastUpdated
          status
          bankTransactionId
          createdBy
          recordedBy{
            id
          }
          totalInvoiced
          creditNote
          upload{
            id
            file
          }
          message{
            id
            message
          }
        },
        next,
        previous,
        summary{
          header,
          body,
          footer
        }
      }
    }
    `;
    return query;
}


export const getFinancialsGraphQuery = (params) => {
  let defaultParams = {propertyIds:[]};
  let combinedParams = {...defaultParams, ...params};
  const { propertyIds } = combinedParams;
  const query = `
    query{
      financialsGraph(
        propertyIds: ${JSON.stringify(propertyIds)}
      ){
        payments
        invoices
        expenses
        year
        month
      }
    }
  `;
  return query;
}


export const addPaymentMutation = (tenantId, amount, paymentType, description,
  creditNote, status, paymentDate, bankTransactionId, sendReceipt = false) => {
    let tenantIdArgument = (tenantId === "") ? "" : `tenantId: ${JSON.stringify(tenantId)},`;

    const mutation = `
        mutation ($file: Upload){
            addPayment(
              ${tenantIdArgument} amount:${amount}, paymentType: "${paymentType}",
              description:${JSON.stringify(description)}, creditNote:${creditNote}, status: "${status}",
              paymentDate:"${paymentDate}", bankTransactionId: "${bankTransactionId}", fileUpload: $file, sendReceipt: ${sendReceipt}
            ){
              error{
                code
                message
              }
            payment{
              id
              amount
              createdTs
              description
              paymentType
              paymentDate
              status
              creditNote
              lastUpdated
              totalInvoiced
              createdBy
              bankTransactionId
              upload{
                id
                file
              }
              tenantDetails{
                tenantId
                firstName
                lastName
                unitId
                propertyId
                archived
                accountBalance
              }
              recordedBy{
                id
              }
              message{
                id
                message
              }
            }
            }
          }`;
    return mutation;
}

export const assignPaymentMutation = (tenantId, paymentId) => {

  const mutation = `
    mutation{
      assignPaymentToTenant(tenantId:${JSON.stringify(tenantId)} ,paymentId:${JSON.stringify(paymentId)}){
      error{
        code
        message
      }
      payment{
        id
        amount
        createdTs
        description
        paymentType
        paymentDate
        status
        creditNote
        lastUpdated
        totalInvoiced
        createdBy
        bankTransactionId
        tenantDetails{
          tenantId
          firstName
          lastName
          unitId
          propertyId
          archived
          accountBalance
        }
        recordedBy{
          id
        }
        message{
          id
          message
        }
      }
      }
      }
    `
      ;
      return mutation;
}

export const reallocatePaymentMutation = (tenantId, paymentId) => {

  const mutation = `
    mutation{
      reallocatePaymentToAnotherTenant(tenantId:${JSON.stringify(tenantId)} ,paymentId:${JSON.stringify(paymentId)}){
      error{
        code
        message
      }
      payment{
        id
        amount
        createdTs
        description
        paymentType
        paymentDate
        status
        creditNote
        lastUpdated
        totalInvoiced
        createdBy
        bankTransactionId
        tenantDetails{
          tenantId
          firstName
          lastName
          unitId
          propertyId
          archived
          accountBalance
        }
        recordedBy{
          id
        }
        message{
          id
          message
        }
      }
      }
      }
    `
      ;
      return mutation;
}

export const updatePaymentMutation = (paymentId, params={tenantId: "", amount: "", paymentType:"", description: "",
  status: "", paymentDate:"", bankTransactionId: "", updateFile: false, sendReceipt: false }) => {
        const {
          tenantId, amount, paymentType, description, status,
          paymentDate, updateFile, bankTransactionId, sendReceipt
        } = params;
        let tenantIdArgument = (tenantId === "") ? "" : `tenantId: ${JSON.stringify(tenantId)},`
        const mutation = `
            mutation ($file: Upload){
              updatePayment(
                paymentId: ${JSON.stringify(paymentId)}, ${tenantIdArgument} amount:${amount},
                paymentType: "${paymentType}", description:${JSON.stringify(description)}, status: "${status}",
                paymentDate:"${paymentDate}", updateFile: ${updateFile}, bankTransactionId: "${bankTransactionId}",
                fileUpload: $file, sendReceipt: ${Boolean(sendReceipt)}
              ){
                error{
                  code
                  message
                }
              payment{
                id
                amount
                createdTs
                description
                paymentType
                paymentDate
                status
                creditNote
                lastUpdated
                totalInvoiced
                createdBy
                bankTransactionId
                upload{
                  id
                  file
                }
                tenantDetails{
                  tenantId
                  firstName
                  lastName
                  unitId
                  propertyId
                  archived
                  accountBalance
                }
                recordedBy{
                  id
                }
                message{
                  id
                  message
                }
              }
            }
          }
        `;
        return mutation;

}

export const deletePaymentsMutation = (paymentIds) => {
  const mutation = `
      mutation{
          deletePayment(paymentIds: ${JSON.stringify(paymentIds)}){
          error{
            code
            message
          }
          success
      }
      }
  `;
  return mutation;
}